import { ONBOARDING_2024_ROUTES } from '../types';

export const ONBOARDING_2024_IN_PROGRESS = 'onboarding_2024_in_progress';
export const ONBOARDING_2024_CURRENT_STEP = 'onboarding_2024_current_step';
export const ONBOARDING_2024_SELECTED_PLAN = 'onboarding_2024_selected_plan';
export const ONBOARDING_2024_FLAG_STORAGE = 'onboarding_2024_flag_storage';
export const ONBOARDING_2024_MONTHLY_VOLUME = 'onboarding_2024_monthly_volume';

export const ONBOARDING_2024_ALLOWED_ROUTES: { [key: string]: string[] } = {
  [ONBOARDING_2024_ROUTES.plan]: [ONBOARDING_2024_ROUTES.connectStore, '/settings/api'],
  [ONBOARDING_2024_ROUTES.connectStore]: [
    ONBOARDING_2024_ROUTES.plan,
    '/orders/create',
    '/orders/csv-import',
  ],
};
